exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Website: https://www.4myth.com\n * Email: mythpe@gmail.com\n * Mobile: +966590470092\n * Copyright © 2018-2024  All rights reserved.\n * MyTh Ahmed\n */.v-item-group{flex:0 1 auto;position:relative;max-width:100%;transition:.3s cubic-bezier(0.25, 0.8, 0.5, 1)}", ""]);

// exports
